// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"195d2744","667":"49df3335","977":"b5b3868f"}[chunkId] + ".chunk.js";
};